import React, { useState, useEffect } from 'react';
import { DependenteEntidade } from '../../../entidades';
import { Alert } from '@intech/web-ui';

import { LoadingComponent } from '../../../components/LoadingComponent';
import { GrayBox } from '../styles';
import { THeader } from './THeader';
import { TBody } from './TBody';
import { DepTable } from './styles';

interface IProps {
  dependentes: Array<DependenteEntidade> | undefined
}

export const Dependentes: React.FC<IProps> = ({
  dependentes
}) => {

  const [AlertText, setAlertText] = useState<string>("");
  const [Dependentes, setDependentes] = useState<Array<DependenteEntidade> | undefined>(new Array<DependenteEntidade>());

  useEffect(() => {
    (async () => {
      try {
        setDependentes(dependentes);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  function renderDependentes() {
    if (Dependentes !== undefined) {
      if (Dependentes.length > 0) {
        const Itens = Dependentes.map((dep: DependenteEntidade, index: number) => {
          return (
            <TBody
              key={index}
              Dependente={dep}
            />
          );
        });
        return (
          <GrayBox title={"Beneficiários"}>
            <DepTable>
              <THeader />

              {Itens}
            </DepTable>
          </GrayBox>
        );
      }

      if (Dependentes.length === 0) {
        return null;
      }
    }

    if (AlertText !== "") {
      return (
        <Alert type={"danger"}>
          {AlertText}
        </Alert>
      );
    }

    return <LoadingComponent />;
  }

  return renderDependentes();
}